import React from "react";
import { Layout, Button, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import Headerdiv from "./layout/header";
import Footerdiv from "./layout/footer";
import {
  HomeOutlined,
  LockOutlined,
  LogoutOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import "../styles/fluidDesign.css";

const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <Layout className="fluid-page">
      <Headerdiv />

      <div className="fluid-page-header">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <Space direction="vertical" size={0}>
          <h1 className="fluid-page-title">
            <LockOutlined /> Access Denied
          </h1>
          <p className="fluid-page-subtitle">
            You attempted to open a page that your role is not permitted to view
          </p>
        </Space>
      </div>

      <Content className="fluid-content">
        <div
          className="fluid-card"
          style={{
            maxWidth: 620,
            margin: "48px auto",
            padding: "48px 32px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 88,
              height: 88,
              borderRadius: "50%",
              margin: "0 auto 24px",
              background: "rgba(255, 77, 79, 0.1)",
              border: "2px solid rgba(255, 77, 79, 0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SafetyOutlined style={{ fontSize: 42, color: "#ff4d4f" }} />
          </div>

          <Title level={3} style={{ marginBottom: 8, color: "var(--fluid-text)" }}>
            You can't access this page
          </Title>
          <Paragraph type="secondary" style={{ fontSize: 14, marginBottom: 8 }}>
            Your current role does not have permission to view this page. The page
            may have been disabled for you by an administrator.
          </Paragraph>
          <Text
            style={{
              display: "inline-block",
              fontSize: 12,
              color: "var(--fluid-text-muted)",
              marginBottom: 28,
            }}
          >
            If you believe this is a mistake, please contact your system
            administrator.
          </Text>

          <div>
            <Space wrap style={{ justifyContent: "center" }}>
              <Button
                type="primary"
                icon={<HomeOutlined />}
                className="fluid-btn-primary"
                onClick={() => navigate("/dash")}
              >
                Back to Dashboard
              </Button>
              <Button
                danger
                icon={<LogoutOutlined />}
                onClick={handleLogout}
              >
                Sign Out
              </Button>
            </Space>
          </div>
        </div>
      </Content>

      <Footerdiv />
    </Layout>
  );
};

export default AccessDenied;
